import React from 'react';
import BeaconProWaterfallChart from 'src/components/EntityPage/WaterfallChart/BeaconProWaterfallChart';
import BeaconProWaterfallUnitsSoldTable from 'src/components/EntityPage/WaterfallChart/BeaconProWaterfallUnitsSoldTable';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';

/**
 * Waterfall chart and units sold table for the summary page
 */
export default function BeaconProWaterfallPageLayout() {
  return (
    <BasePageContainer>
      <Flex gap={BEACON_CHART_SPACING} flexDirection="column">
        <BeaconProWaterfallChart />
        <BeaconProWaterfallUnitsSoldTable />
      </Flex>
    </BasePageContainer>
  );
}
